/* =========================================================
   twp-pricing.mjs: The Window Place window prices (the one copy)
   Used by the Hub's TWP Price Calculator (src/services/twp-pricing.js re-exports this file)
   and by the website's team side (website-functions/pricing/priceDesign.mjs) to price
   designs in the dashboard's Design studio. Never sent to the public website.
   Change prices here and both stay the same.
========================================================= */
const PRICING = {
  "Double Hung": {
    axis: "height_x_width",
    variants: ["White", "Woodgrain"],
    White: {
      heightRanges: ["23.5-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84"],
      widthRanges:  ["16-24", "24.0625-30", "30.0625-36", "36.0625-42", "42.0625-52"],
      table: [[500,520,580,650,700],[520,560,630,670,740],[530,580,650,700,790],[560,630,670,740,820],[null,680,730,810,880]],
    },
    Woodgrain: {
      heightRanges: ["23.5-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84"],
      widthRanges:  ["16-24", "24.0625-30", "30.0625-36", "36.0625-42", "42.0625-52"],
      table: [[670,700,790,870,930],[700,760,840,880,990],[720,790,870,930,1040],[760,840,880,990,1090],[null,900,970,1070,1180]],
    },
  },
  "Picture Window": {
    axis: "height_x_width",
    variants: ["White", "Woodgrain"],
    White: {
      heightRanges: ["11.5-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84"],
      widthRanges:  ["11.5-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[340,340,410,420,490,620],[340,410,420,510,620,690],[410,420,510,620,690,750],[420,490,620,690,750,830],[490,620,690,750,830,890]],
    },
    Woodgrain: {
      heightRanges: ["11.5-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84"],
      widthRanges:  ["11.5-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[440,440,520,550,620,760],[440,520,550,650,760,850],[520,550,650,760,850,930],[550,620,760,850,930,1020],[620,760,850,930,1020,1100]],
    },
  },
  "Casement": {
    axis: "height_x_width",
    variants: ["1-Lite", "2-Lite", "3-Lite", "4-Lite"],
    "1-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-61.875", "62-75"],
      widthRanges:  ["16-34", "34.0625-36"],
      table: [[450,520,590,690,850],[490,570,660,760,930]],
    },
    "2-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-61.875", "62-75"],
      widthRanges:  ["29-68", "68.125-72"],
      table: [[890,1040,1190,1380,1690],[980,1150,1320,1520,1860]],
    },
    "3-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-61.875", "62-75"],
      widthRanges:  ["50-110"],
      table: [[1280,1550,1780,2070,2530]],
    },
    "4-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-61.875", "62-75"],
      widthRanges:  ["74-133"],
      table: [[1670,2070,2380,2750,3360]],
    },
  },
  "Awning": {
    axis: "height_x_width",
    variants: ["1-Lite", "2-Lite"],
    "1-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-52"],
      widthRanges:  ["16-34"],
      table: [[450,520,590,670]],
    },
    "2-Lite": {
      heightRanges: ["16-25.875", "26-37.875", "38-49.875", "50-52"],
      widthRanges:  ["32-68"],
      table: [[890,1040,1190,1330]],
    },
  },
  "3 Lite Slider": {
    axis: "width_x_height",
    variants: ["White", "Woodgrain"],
    White: {
      widthRanges:  ["42-48", "48.0625-60", "60.0625-72", "72.0625-84", "84.0625-104"],
      heightRanges: ["18-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[610,650,730,820,970],[650,740,820,900,1050],[730,830,900,1000,1150],[null,900,1000,1080,1230],[null,1000,1080,1180,1330]],
    },
    Woodgrain: {
      widthRanges:  ["42-48", "48.0625-60", "60.0625-72", "72.0625-84", "84.0625-104"],
      heightRanges: ["18-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[830,890,1000,1100,1310],[890,1020,1100,1220,1430],[1000,1130,1220,1350,1550],[null,1220,1350,1460,1680],[null,1350,1460,1590,1790]],
    },
  },
  "Slider": {
    axis: "width_x_height",
    variants: ["White", "Woodgrain"],
    White: {
      widthRanges:  ["23.5-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84", "84.0625-96"],
      heightRanges: ["18-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[490,510,580,650,720,810],[510,580,650,720,810,880],[580,650,720,810,880,970],[650,720,810,880,970,1040],[null,810,880,970,1040,1130]],
    },
    Woodgrain: {
      widthRanges:  ["23.5-36", "36.0625-48", "48.0625-60", "60.0625-72", "72.0625-84", "84.0625-96"],
      heightRanges: ["18-24", "24.0625-36", "36.0625-48", "48.0625-60", "60.0625-72"],
      table: [[650,680,760,850,940,1040],[680,760,850,940,1040,1150],[760,850,940,1040,1150,1250],[850,940,1040,1150,1250,1360],[null,1040,1150,1250,1360,1460]],
    },
  },
};

const GRIDS_PER_SQFT = 4.28;

// ── Default mull & install constants ─────────────────────────────────────────
const MULL_PRICE_DEFAULT     = 120;   // $ per mull
const INSTALL_BASE_DEFAULT   = 250;   // $ base install fee per window
const INSTALL_MULT_DEFAULT   = 1.0;   // multiplier for single window (not used for mulled)

// ── Range lookup helper ───────────────────────────────────────────────────────
function findRangeIndex(value, ranges) {
  const v = parseFloat(value);
  if (isNaN(v)) return -1;
  for (let i = 0; i < ranges.length; i++) {
    const clean = ranges[i].replace(/["\\']/g, '').trim();
    const parts = clean.split('-').map(p => parseFloat(p.trim()));
    if (parts.length === 2 && v >= parts[0] && v <= parts[1]) return i;
  }
  return -1;
}

// ── Single window price lookup ────────────────────────────────────────────────
export function lookupTWPPrice(windowType, variant, width, height) {
  const typeData = PRICING[windowType];
  if (!typeData) return null;
  const variantData = typeData[variant];
  if (!variantData) return null;
  let rowIdx, colIdx;
  if (typeData.axis === "width_x_height") {
    colIdx = findRangeIndex(width, variantData.widthRanges);
    rowIdx = findRangeIndex(height, variantData.heightRanges);
  } else {
    colIdx = findRangeIndex(height, variantData.heightRanges);
    rowIdx = findRangeIndex(width, variantData.widthRanges);
  }
  if (rowIdx === -1 || colIdx === -1) return null;
  const price = variantData.table[rowIdx]?.[colIdx];
  return price ?? null;
}

// ── Mulled unit calculator ────────────────────────────────────────────────────
//
// grid: array of rows, each row is an array of pane objects:
//   { windowType, variant, width, height }
//
// overrides: optional object to override auto-calculated defaults:
//   {
//     vertMullCount,       // number of vertical mulls (default: (cols-1) * rows)
//     horizMullCount,      // number of horizontal mulls (default: rows-1)
//     mullPrice,           // $ per mull (default: 120)
//     includeMulls,        // boolean (default: true)
//     installMultiplier,   // e.g. 2.5 (default: auto from windowCount)
//     installBase,         // $ base (default: 250)
//     includeInstall,      // boolean (default: true)
//   }
//
// Returns a detailed breakdown object the UI can render directly.
//
export function calculateMulledUnit(grid, overrides = {}) {
  if (!grid || grid.length === 0) return null;

  const rows = grid.length;
  const cols = grid[0].length;
  const windowCount = rows * cols;

  // ── Per-pane pricing ────────────────────────────────────────────────────
  const panes = [];
  let windowPriceTotal = 0;

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      const pane = grid[r][c];
      const price = lookupTWPPrice(pane.windowType, pane.variant, pane.width, pane.height);
      const paneResult = {
        row: r,
        col: c,
        label: `R${r + 1}C${c + 1}`,
        windowType: pane.windowType,
        variant: pane.variant,
        width: pane.width,
        height: pane.height,
        price,           // null if out of range
        outOfRange: price === null,
      };
      panes.push(paneResult);
      if (price !== null) windowPriceTotal += price;
    }
  }

  // ── Mull counts ─────────────────────────────────────────────────────────
  // Vertical mulls: between columns, one per row  →  (cols - 1) × rows
  // Horizontal mulls: between rows, one rail total  →  (rows - 1)
  const defaultVertMulls  = (cols - 1) * rows;
  const defaultHorizMulls = rows - 1;
  const defaultTotalMulls = defaultVertMulls + defaultHorizMulls;

  const vertMullCount  = overrides.vertMullCount  ?? defaultVertMulls;
  const horizMullCount = overrides.horizMullCount ?? defaultHorizMulls;
  const totalMulls     = vertMullCount + horizMullCount;
  const mullPrice      = overrides.mullPrice      ?? MULL_PRICE_DEFAULT;
  const includeMulls   = overrides.includeMulls   ?? true;
  const mullTotal      = includeMulls ? totalMulls * mullPrice : 0;

  // ── Installation fee ─────────────────────────────────────────────────────
  // Formula: (1 + windowCount × 0.5) × installBase
  // e.g. 2 windows → 1.5 × 250 = $375
  //      3 windows → 2.0 × 250 = $500
  //      6 windows → 4.0 × 250 = $1000
  const defaultInstallMultiplier = 1 + windowCount * 0.5;
  const installMultiplier = overrides.installMultiplier ?? defaultInstallMultiplier;
  const installBase       = overrides.installBase       ?? INSTALL_BASE_DEFAULT;
  const includeInstall    = overrides.includeInstall    ?? true;
  const installTotal      = includeInstall
    ? Math.round(installMultiplier * installBase * 100) / 100
    : 0;

  // ── Grand total ──────────────────────────────────────────────────────────
  const grandTotal = Math.round((windowPriceTotal + mullTotal + installTotal) * 100) / 100;

  // ── Flat list for cut list (exploded panes) ──────────────────────────────
  // Each pane carries its own individual price for QuickBooks reference
  const cutlistWindows = panes.map(p => ({
    windowType: p.windowType,
    variant:    p.variant,
    width:      p.width,
    height:     p.height,
    mullLabel:  p.label,          // e.g. "R1C1"
    price:      p.price || 0,     // individual window price for QuickBooks
    outOfRange: p.outOfRange || false,
  }));

  return {
    // Grid geometry
    rows,
    cols,
    windowCount,

    // Per-pane breakdown
    panes,
    windowPriceTotal,

    // Mull breakdown
    defaultVertMulls,
    defaultHorizMulls,
    defaultTotalMulls,
    vertMullCount,
    horizMullCount,
    totalMulls,
    mullPrice,
    includeMulls,
    mullTotal,

    // Install breakdown
    defaultInstallMultiplier,
    installMultiplier,
    installBase,
    includeInstall,
    installTotal,

    // Grand total
    grandTotal,

    // For cut list
    cutlistWindows,

    // Any panes that couldn't be priced
    hasOutOfRange: panes.some(p => p.outOfRange),
    outOfRangePanes: panes.filter(p => p.outOfRange).map(p => p.label),
  };
}

// ── Default mull config (used to initialize UI state) ────────────────────────
export function getDefaultMullConfig(rows, cols) {
  const windowCount    = rows * cols;
  const vertMulls      = (cols - 1) * rows;
  const horizMulls     = rows - 1;
  return {
    vertMullCount:      vertMulls,
    horizMullCount:     horizMulls,
    mullPrice:          MULL_PRICE_DEFAULT,
    includeMulls:       true,
    installMultiplier:  1 + windowCount * 0.5,
    installBase:        INSTALL_BASE_DEFAULT,
    includeInstall:     true,
  };
}

export { PRICING, GRIDS_PER_SQFT, MULL_PRICE_DEFAULT, INSTALL_BASE_DEFAULT };

// ── Grid pricing constants ────────────────────────────────────────────────────
export const GRID_PRICE_PER_SQFT = 4.28;

export const GLASS_OPTIONS   = ['None', 'Obscure', 'Gray Tint', 'Bronze Tint', 'Tempered'];
export const GLASS_PACKAGES  = ['DC', 'DCA', 'DLA', 'TLA', 'TLK'];
export const GRID_TYPES      = ['None', 'Flat', 'Contoured'];
export const GRID_PATTERNS   = ['None', 'Colonial', 'Prairie', 'Diamond', 'Cottage', 'Craftsman'];

// Windows with two sashes (keeper = bottom, lock = top, each ~half height)
const TWO_SASH_TYPES = ['Double Hung', 'Slider', '3 Lite Slider'];

// Calculate grid price for a single window
// keeperGrids / lockGrids: { gridType, gridPattern, verticals, horizontals }
// Returns { keeperGridPrice, lockGridPrice, totalGridPrice }
export function calculateGridPrice(windowType, width, height, keeperGrids, lockGrids) {
  const w = parseFloat(width)  || 0;
  const h = parseFloat(height) || 0;
  if (w <= 0 || h <= 0) return { keeperGridPrice: 0, lockGridPrice: 0, totalGridPrice: 0 };

  const sqft = (w * h) / 144;
  const isTwoSash = TWO_SASH_TYPES.includes(windowType);

  // For two-sash windows each sash is half the height
  const keeperSqft = isTwoSash ? (w * (h / 2)) / 144 : sqft;
  const lockSqft   = isTwoSash ? (w * (h / 2)) / 144 : 0; // single sash windows have no lock glass section

  function hasGrids(cfg) {
    return cfg && cfg.gridPattern && cfg.gridPattern !== 'None';
  }

  const keeperGridPrice = hasGrids(keeperGrids) ? Math.round(keeperSqft * GRID_PRICE_PER_SQFT * 100) / 100 : 0;
  const lockGridPrice   = hasGrids(lockGrids)   ? Math.round(lockSqft   * GRID_PRICE_PER_SQFT * 100) / 100 : 0;
  const totalGridPrice  = keeperGridPrice + lockGridPrice;

  return { keeperGridPrice, lockGridPrice, totalGridPrice };
}

// Build a glass config summary string for display/PDF
export function describeGlassConfig(keeperCfg, lockCfg, windowType) {
  const isTwoSash = TWO_SASH_TYPES.includes(windowType);
  const parts = [];

  function cfgStr(cfg, label) {
    if (!cfg) return;
    const bits = [];
    if (cfg.glassPackage) bits.push(cfg.glassPackage);
    if (cfg.glassOption && cfg.glassOption !== 'None') bits.push(cfg.glassOption);
    if (cfg.gridPattern && cfg.gridPattern !== 'None') {
      let gridStr = cfg.gridPattern;
      if (cfg.gridType && cfg.gridType !== 'None') gridStr = cfg.gridType + ' ' + gridStr;
      if (cfg.verticals || cfg.horizontals) gridStr += ` (${cfg.verticals||0}V × ${cfg.horizontals||0}H)`;
      bits.push(gridStr);
    }
    if (bits.length) parts.push((isTwoSash ? label + ': ' : '') + bits.join(', '));
  }

  cfgStr(keeperCfg, 'Keeper');
  if (isTwoSash) cfgStr(lockCfg, 'Lock');
  return parts.join(' | ');
}

// Glass upgrade pricing (2026 — Tracy Corners IG wholesale +5%, no markup)
// Default for all TWP windows is Low E Argon at no extra cost.
// These rates apply per pane based on its sqft. Mins apply for tempered.
export const GLASS_UPGRADE = {
  obscure:           { rate: 9.30,  min: 0,     label: 'Obscure (Low E)'        },
  tint:              { rate: 6.25,  min: 0,     label: 'Tint'                   },
  tempered:          { rate: 16.70, min: 50.13, label: 'Tempered (Low E)'       },
  temperedTint:      { rate: 7.30,  min: 0,     label: 'Tempered Tint'          },
  temperedObscure:   { rate: 3.25,  min: 0,     label: 'Tempered Obscure'       },
};

// Pick the right upgrade key based on glassOption + tempered flag.
// Returns null if no upgrade applies.
export function pickGlassUpgrade(cfg) {
  const opt = cfg?.glassOption || 'None';
  const isTint = opt === 'Gray Tint' || opt === 'Bronze Tint';
  const isObscure = opt === 'Obscure';
  const tempered = !!cfg?.tempered;
  if (tempered && isTint)    return 'temperedTint';
  if (tempered && isObscure) return 'temperedObscure';
  if (tempered)              return 'tempered';
  if (isTint)                return 'tint';
  if (isObscure)             return 'obscure';
  return null;
}

// Compute the actual GLASS sqft (not pane-overall) for a pane.
// Allowances pulled from src/calculations/*.js so we match what we
// order from Tracy Corners IG.
//   - HS:       sashW - 1.6875,  sashH - 2.9375  (from hs.js line 133-134)
//   - PW:       W     - 4.25,    H     - 5.375   (from pw.js line 116-117)
//   - Casement: sashW - 2.125,   sashH - 3.25    (from csmt.js line 216-217)
//   - DH:       approx 3" each side (close enough — real K/L vary)
//   - 3HS:      same pattern as HS but split in 3
//   - BM/BSMT:  3" each side approximation
//
// paneW/paneH are the FULL window dimensions; this function handles the
// per-sash math internally based on windowType.
export function calcGlassSqft(windowType, paneW, paneH, isLockSash = false) {
  if (!paneW || !paneH) return 0;
  const W = parseFloat(paneW);
  const H = parseFloat(paneH);
  if (isNaN(W) || isNaN(H) || W <= 0 || H <= 0) return 0;

  const t = (windowType || '').toLowerCase();
  let glassW, glassH;

  if (t.includes('horizontal slider') || t === 'hs') {
    // Side-by-side sashes — width is half, height is full
    const sashW = W / 2;
    glassW = sashW - 1.6875;
    glassH = H - 2.9375;
  } else if (t.includes('3-lite') || t === '3hs') {
    // Three lites — equal thirds approximation
    const liteW = W / 3;
    glassW = liteW - 1.6875;
    glassH = H - 2.9375;
  } else if (t.includes('picture') || t === 'pw') {
    // Single pane — full window minus PW allowances
    glassW = W - 4.25;
    glassH = H - 5.375;
  } else if (t.includes('casement') || t === 'csmt') {
    // Casement — single sash, full window dimensions
    glassW = W - 2.125;
    glassH = H - 3.25;
  } else if (t.includes('basement') || t === 'bm' || t === 'bsmt') {
    // Basement — single pane approximation
    glassW = W - 3;
    glassH = H - 3;
  } else {
    // Default: Double Hung (DH) or anything else with two stacked sashes.
    // Each sash is W wide × H/2 tall; allowance ~3" on width, ~3" on height per sash.
    glassW = W - 3;
    glassH = (H / 2) - 3;
  }

  // Guard against tiny/negative sizes on unusual inputs
  glassW = Math.max(0, glassW);
  glassH = Math.max(0, glassH);
  return (glassW * glassH) / 144;
}

// Calculate cost for a single pane's glass upgrade — uses real glass sqft.
export function paneGlassUpgradeCost(cfg, windowType, paneW, paneH, isLockSash = false) {
  const key = pickGlassUpgrade(cfg);
  if (!key || !paneW || !paneH) return { cost: 0, sqft: 0, key: null };
  const sqft = calcGlassSqft(windowType, paneW, paneH, isLockSash);
  const u = GLASS_UPGRADE[key];
  const raw = sqft * u.rate;
  const cost = Math.max(raw, u.min);
  return { cost, sqft, key };
}

// Round to nearest $10 (standard rounding, not always up).
// 1474 → 1470, 1477 → 1480, 1470 → 1470.
export function roundToNearest10(n) {
  if (n === null || n === undefined || isNaN(n)) return n;
  return Math.round(n / 10) * 10;
}
